import { createContext } from "react";
export const AddSourceContext = createContext({});
